import { render, staticRenderFns } from "./CoachingNotepadPage.vue?vue&type=template&id=63a6d68a&"
import script from "./CoachingNotepadPage.vue?vue&type=script&lang=js&"
export * from "./CoachingNotepadPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports